import React from "react";
import { Stack } from "react-bootstrap";
import "react-datetime-picker/dist/DateTimePicker.css";
import styled from "styled-components";
import { InputRow } from "../styles";
import { WashroomsFormViewProps } from "../types";
import { WashroomsFormButtons } from "./WashroomsFormButtons";
import Input from "src/components/Input";
import { useFormContext } from "react-hook-form";

export const WashroomsFormView = ({ onCancel, error, defaultValues, isEditMode }: WashroomsFormViewProps) => {
  const {
    register,
    formState: {},
  } = useFormContext();

  return (
    <Stack gap={3}>
      <InputRow>
        <Input
          label="Washroom ID"
          {...register("id", { required: "Washroom ID is required" })}
          defaultValue={defaultValues?.id}
          // disabled
        />
      </InputRow>
      <InputRow>
        <Input
          // disabled={!isEditMode}
          label="Washroom Label"
          {...register("label", { required: "Washroom Label is required" })}
          defaultValue={defaultValues?.label}
        />
      </InputRow>
      {error && <ErrorMessage>Work Request has not been shared successfully. </ErrorMessage>}
      <WashroomsFormButtons onCancel={onCancel} isEditMode={isEditMode} />
    </Stack>
  );
};

const ErrorMessage = styled.p`
  color: red;
  padding-top: 18px;
  font-size: 10px;
  font-family: Manrope;
  text-align: center;
`;
